import taxpayer from '../../Actions/taxpayer';
const { types } = taxpayer;

const initialState = {
    taxpayerVolume:[]
};

const taxpayerReducer = (state = initialState, action) => {
    switch (action.type) {        
        case types.SET_TAXPAYER_VOLUME_DATA: {
            return {
                ...state,
                taxpayerVolume: action.data
            }
        }
        default:
            return state;
    }
}

export default taxpayerReducer;